import * as _ from 'underscore';

import { IPublishedConnectionTableInfo } from '../models/IPublishedConnectionTableInfo';
import { IUserInfo } from '../models/IUserInfo';
import { INamedItemInfo } from '../models/resourceInfoParts';
import { IPublishedConnectionTable } from '../ServerApi/types/IPublishedConnectionTable';
import { MapperHelper } from './MapperHelper';
import { UserMapper } from './UserMapper';

export module PublishedConnectionTableMapper {
  const M = MapperHelper;

  export function map(
    serverApiMetrics: IPublishedConnectionTable[],
    users: _.Dictionary<IUserInfo>,
    projects: _.Dictionary<INamedItemInfo>,
    favoritePublishedConnectionTables: _.Dictionary<any> = {}
  ): IPublishedConnectionTableInfo[] {
    return serverApiMetrics.map((m: IPublishedConnectionTable) => {
      return mapOne(m, users[m.ownerId], projects[m.projectId], !!favoritePublishedConnectionTables[m.id]);
    });
  }

  // TODO: ntomsic fix this once extracts and policies are in
  export function mapOne(
    publishedConnectionTable: IPublishedConnectionTable,
    owner?: IUserInfo,
    project?: INamedItemInfo,
    favorite?: boolean
  ): IPublishedConnectionTableInfo {
    return {
      createdAt: M.toDate(publishedConnectionTable.createdAt),
      updatedAt: M.toDate(publishedConnectionTable.updatedAt),
      tags: M.sortTags(publishedConnectionTable.tags),
      description: publishedConnectionTable.description,
      id: publishedConnectionTable.id,
      luid: publishedConnectionTable.luid,
      name: publishedConnectionTable.name,
      owner: UserMapper.mapOne(owner),
      favorite: favorite,
      contentType: 'publishedConnectionTable',
      project: project,
      alias: publishedConnectionTable.alias,
      databaseName: publishedConnectionTable.databaseName,
      schemaName: publishedConnectionTable.schemaName
    };
  }
}
